module.exports = __webpack_public_path__ + "img/paciente4.662be3b9.svg";